exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".kloudless-ctrl-container{margin-top:15px;border-top:2px solid #27638c}.kloudless-control-holder{width:100%;border-bottom:1px solid #bbb;display:inline-block;margin-bottom:-8px}.kloudless-service-img{width:40%;float:left;display:block;height:42px;overflow:hidden;margin:10px}.kloudless-service-img img{height:100%;width:auto}.kloudless-service-switch{width:48%;float:left;display:block;padding-top:12px}.kloudless-switch{width:72px;height:30px;display:inline-block;vertical-align:top;margin:5px 0 0 -5px;padding:0;background:url(/sites/all/themes/inforuptcy/images/off_button_small.png) no-repeat 0 0;cursor:pointer}.kloudless-switch.on{background-image:url(\"/sites/all/themes/inforuptcy/images/on_button_small.png\")}.loading-data{padding:20px;display:block;color:#27638c}.error-loading{padding:20px;display:block;text-align:center;font-size:14px;color:red}", ""]);

// exports



/*****************
 ** WEBPACK FOOTER
 ** ./~/css-loader!./src/kloudless/kloudless.css
 ** module id = 1105
 ** module chunks = 0
 **/